const notesState = [
  {
    id: 1732163,
    noteNumber: 1,
    text: 'Какая-то интересная заметка, записана чтобы протестить приложение',
    signature: 'Неизвестный автор, проверка р',
    time: '03/07/2022',
  },
  {
    id: 1231342,
    noteNumber: 2,
    text: 'Какая-то интересная заметка, записана чтобы протестить приложение',
    signature: 'Вася Пупкин',
    time: '03/07/2022',
  },
  {
    id: 1232321342,
    noteNumber: 3,
    text: 'Какая-то интересная заметка, записана чтобы протестить приложение, Какая-то интересная заметка, записана чтобы протестить приложение, Какая-то интересная заметка, записана чтобы протестить приложение,',
    signature: 'Костя Дзю',
    time: '03/07/2022',
  },
  {
    id: 164645433,
    noteNumber: 4,
    text: 'Очень информативная структурированная заметка',
    signature: 'Какой-то чувак',
    time: '03/07/2022',
  },
  {
    id: 1745745632,
    noteNumber: 5,
    text: 'Разрушитель',
    signature: 'Танос',
    time: '03/07/2022',
  },
  {
    id: 137345242,
    noteNumber: 6,
    text: 'Какая-то интересная заметка, записана чтобы протестить приложение, Какая-то интересная заметка, записана чтобы протестить приложение, Какая-то интересная заметка, записана чтобы протестить приложение,Какая-то интересная заметка, записана чтобы протестить приложение, Какая-то интересная заметка, записана чтобы протестить приложение, Какая-то интересная заметка, записана чтобы протестить приложение,Какая-то интересная заметка, записана чтобы протестить приложение, Какая-то интересная заметка, записана чтобы протестить приложение, Какая-то интересная заметка, записана чтобы протестить приложение,Какая-то интересная заметка, записана чтобы протестить приложение, Какая-то интересная заметка, записана чтобы протестить приложение, Какая-то интересная заметка, записана чтобы протестить приложение,Какая-то интересная заметка, записана чтобы протестить приложение, Какая-то интересная заметка, записана чтобы протестить приложение, Какая-то интересная заметка, записана чтобы протестить приложение,',
    signature: 'Петя с 3 подъезда',
    time: '03/07/2022',
  },
  {
    id: 86585433,
    noteNumber: 7,
    text: '',
    signature: 'Чувачок',
    time: '03/07/2022',
  },
  {
    id: 976845745632,
    noteNumber: 8,
    text: 'Какая-то интересная заметка, записана чтобы протестить приложение',
    signature: 'А.С Пушкин',
    time: '03/07/2022',
  },
  {
    id: 4563345242,
    noteNumber: 9,
    text: '',
    signature: 'Братулек',
    time: '03/07/2022',
  },
];

export default notesState;
